import Vue from 'vue'
import Vuex from 'vuex'
import verifyUserStoreModule from './verifyUserStore.js'
import createPersistedState from 'vuex-persistedstate'
import VueCryptojs from "vue-cryptojs";

Vue.use(Vuex)
Vue.use(VueCryptojs)

export default new Vuex.Store({
	state: {
		token: '',
		user: {
			userName: '',
			password: ''
		},
		id: '',
		cartProducts: [],
		name: '',
		userData: {},
		voucherCodeId: '',
		voucherCode:''
	},
	plugins: [
		createPersistedState({
			paths: ['user', 'token', 'id', 'cartProducts', 'name', 'userData', 'voucherCodeId','voucherCode'],
		}),
	],
	mutations: {
		setUser(state, user) {
			state.user = user
		},
		setToken(state, token) {
			state.token = token
		},
		setUserId(state, id) {
			state.id = id
		},
		setUserName(state, name) {
			state.name = name
		},
		addProductToCart(state, product) {
			state.cartProducts = [product, ...state.cartProducts]
		},
		removeProductFromCart(state, productId) {
			state.cartProducts = state.cartProducts.filter((product) => product.id !== productId)
		},
		updateCartProducts(state, products) {
			state.cartProducts = products
		},
		increaseProductQuantity(state, productId) {
			state.cartProducts = state.cartProducts.map((product) => {
				if (product.id !== productId) return product
				return {
					...product,
					quantity: product.quantity + 1,
				}
			})
		},
		decreaseProductQuantity(state, productId) {
			state.cartProducts = state.cartProducts.map((product) => {
				if (product.id !== productId) return product

				if (product.quantity <= 1) return product
				return {
					...product,
					quantity: product.quantity - 1,
				}
			})
		},
		setUserData(state, userData) {
			state.userData = userData
		},
		resetCart(state) {
			state.cartProducts = []
		},
		SET_VOUCHER_CODE(state, voucherCode) {
			state.voucherCode = voucherCode
		},
		RESET_VOUCHER_CODE(state, voucherCode){
			state.voucherCode = voucherCode
		},
		SET_VOUCHER_CODE_ID(state, voucherCodeId) {
			state.voucherCodeId = voucherCodeId
		},
		RESET_VOUCHER_CODE_ID(state) {
			state.voucherCodeId = null
		},
	},
	getters: {
		getToken(state) {
			return state.token
		},
		getUserId(state) {
			return state.id
		},
		getUser(state) {
			return state.user
		},
		getUserName(state) {
			return state.name
		},
		getUserData(state) {
			return state.userData
		}
	},
	modules: {
		verifyUserStore: verifyUserStoreModule,
	},
})
